// src/pages/vendor/FarmerVendorLogin.js
import { useState } from "react";
import { auth } from "../../firebaseConfig";
import { signInWithEmailAndPassword } from "firebase/auth";

function FarmerVendorLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    try {
      setLoading(true);
      await signInWithEmailAndPassword(auth, email.trim(), password);
      window.location.href = "/vendor/dashboard";
    } catch (err) {
      console.error("Vendor login error:", err);
      alert("Login failed: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-100 via-slate-50 to-slate-100 py-10">
      <div className="max-w-md mx-auto px-4">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-xl p-6">
          <h1 className="text-2xl font-extrabold text-slate-900 mb-2 text-center">
            Farmer Vendor Login
          </h1>
          <p className="text-xs text-slate-500 mb-5 text-center">
            Use the email &amp; password created during vendor registration.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4 text-sm">
            <div>
              <label className="block text-xs font-semibold mb-1">
                Email (Login ID)
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                required
              />
            </div>
            <div>
              <label className="block text-xs font-semibold mb-1">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full mt-2 px-4 py-2 rounded-full bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 text-white font-semibold text-sm hover:from-purple-700 hover:via-pink-700 hover:to-rose-700 disabled:opacity-60"
            >
              {loading ? "Logging in…" : "Login"}
            </button>
          </form>

          <p className="mt-4 text-[11px] text-slate-500 text-center">
            New vendor?{" "}
            <a
              href="/vendor/signup"
              className="text-emerald-700 font-semibold hover:underline"
            >
              Register here
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default FarmerVendorLogin;
